import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { customerLogin } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import './CustomerLogin.css';

const CustomerLogin: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login: authLogin } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await customerLogin({ email, password });
      if (response.success && response.data.token) {
        const customer = response.data.customer;
        const displayName = (customer?.business_name && customer.business_name.trim() !== '')
          ? customer.business_name
          : (customer?.customer_name ?? '');
        authLogin(response.data.token, 'customer', displayName);
        navigate('/customer/dashboard');
      } else {
        setError(response.error || 'Login failed');
      }
    } catch (err: any) {
      setError(err.message || 'An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="customer-login-container">
      <div className="customer-login-card">
        <div className="customer-login-header">
          <h1>Promoter Login</h1>
          <p>Create promotions and reach society residents</p>
        </div>

        <form onSubmit={handleSubmit} className="customer-login-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
            />
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <p className="register-link">
            Don't have an account? <Link to="/customer/register">Register</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default CustomerLogin;
